import script from "./InternalChatBubble.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternalChatBubble.vue?vue&type=script&setup=true&lang=ts"

import "./InternalChatBubble.vue?vue&type=style&index=0&id=0667af8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0667af8c"]])

export default __exports__